/**
 * Reusable up/down/flat delta indicator used in the RankTab keyword table for both
 * the "vs last run" and "Δ since baseline" columns. Captures the boring colour-coding
 * branches in one place so callers just pass a numeric delta.
 *
 * delta > 0  → green up arrow + "+N"  (rank improved — lower position number is better)
 * delta < 0  → red down arrow + "-N"
 * delta = 0  → grey minus + "0"
 * delta null → grey "—"
 */
import React from "react";
import { ArrowUp, ArrowDown, Minus } from "lucide-react";

export default function RankDeltaCell({ delta, testid }) {
  if (delta == null) {
    return (
      <span className="text-[#a0aec0] inline-flex items-center gap-1" data-testid={testid}>
        <Minus className="h-3 w-3" /> —
      </span>
    );
  }
  if (delta > 0) {
    return (
      <span className="text-[#48bb78] font-semibold inline-flex items-center gap-1" data-testid={testid}>
        <ArrowUp className="h-3 w-3" /> +{delta}
      </span>
    );
  }
  if (delta < 0) {
    return (
      <span className="text-[#f56565] font-semibold inline-flex items-center gap-1" data-testid={testid}>
        <ArrowDown className="h-3 w-3" /> {delta}
      </span>
    );
  }
  return (
    <span className="text-[#a0aec0] inline-flex items-center gap-1" data-testid={testid}>
      <Minus className="h-3 w-3" /> 0
    </span>
  );
}
